var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns my-0 is-multiline"},[_c('div',{staticClass:"column is-5"},[_c('kst-input',{attrs:{"floating-label":"","load-on-focus":"","field":"Search","data":_vm.searchData,"catalog":_vm.SearchCatalog},on:{"input":_vm.handleInput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }